import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, auth } from "../lib/api";
import { Sparkle } from "@phosphor-icons/react";

export default function Register() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "Like Digital S.r.l." });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      auth.setSession(data.access_token, data.user);
      // seed demo data
      try { await api.post("/seed"); } catch {}
      nav("/");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Errore di registrazione");
    } finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-8">
      <form onSubmit={submit} className="w-full max-w-md space-y-5 bg-white border border-zinc-200 p-8" data-testid="register-form">
        <div className="flex items-center gap-2 mb-2">
          <Sparkle weight="fill" className="text-klein" size={22} />
          <span className="font-display font-extrabold tracking-tight">GARE MANAGER AI</span>
        </div>
        <h1 className="font-display text-3xl font-extrabold tracking-tighter">Crea account</h1>
        <p className="text-sm text-zinc-500 -mt-3">Verra creato anche un tenant demo con dati di esempio.</p>

        <div className="space-y-3">
          <Input label="Nome" testid="reg-name" required value={form.name} onChange={upd("name")} />
          <Input label="Email" type="email" testid="reg-email" required value={form.email} onChange={upd("email")} />
          <Input label="Password" type="password" testid="reg-password" required value={form.password} onChange={upd("password")} />
          <Input label="Azienda" testid="reg-company" value={form.company} onChange={upd("company")} />
        </div>

        {err && <div data-testid="register-error" className="text-sm text-red-600 border-l-2 border-red-500 pl-3 py-1">{err}</div>}

        <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? "Creazione..." : "Crea account"}
        </button>

        <div className="text-sm text-zinc-500 text-center">
          Hai gia un account? <Link to="/login" className="text-klein font-medium hover:underline">Accedi</Link>
        </div>
      </form>
    </div>
  );
}

function Input({ label, testid, ...props }) {
  return (
    <div>
      <label className="label-up mb-1 block">{label}</label>
      <input data-testid={testid} className="input-field" {...props} />
    </div>
  );
}
